import { arabicFlashcards } from "./flashcardDataArabic_v100.js";
import { bengaliFlashcards } from "./flashcardDataBengali_v100.js";
import { chineseFlashcards } from "./flashcardDataChinese_v100.js";
import { frenchFlashcards } from "./flashcardDataFrench_v100.js";
import { germanFlashcards } from "./flashcardDataGerman_v100.js";
import { greekFlashcards } from "./flashcardDataGreek_v100.js";
import { hindiFlashcards } from "./flashcardDataHindi_v100.js";
import { italianFlashcards } from "./flashcardDataItalian_v100.js";
import { japaneseFlashcards } from "./flashcardDataJapanese_v100.js";
import { kannadaFlashcards } from "./flashcardDataKannada_v100.js";
import { latinFlashcards } from "./flashcardDataLatin_v100.js";
import { malayalamFlashcards } from "./flashcardDataMalayalam_v100.js";
import { marathiFlashcards } from "./flashcardDataMarathi_v100.js";
import { portugueseFlashcards } from "./flashcardDataPortuguese_v100.js";
import { punjabiFlashcards } from "./flashcardDataPunjabi_v100.js";
import { russianFlashcards } from "./flashcardDataRussian_v100.js";
import { spanishFlashcards } from "./flashcardDataSpanish_v100.js";
import { tamilFlashcards } from "./flashcardDataTamil_v100.js";
import { teluguFlashcards } from "./flashcardDataTelugu_v100.js";
import { urduFlashcards } from "./flashcardDataUrdu_v100.js";

export const flashcardData = {
  Arabic: arabicFlashcards,
  Bengali: bengaliFlashcards,
  Chinese: chineseFlashcards,
  French: frenchFlashcards,
  German: germanFlashcards,
  Greek: greekFlashcards,
  Hindi: hindiFlashcards,
  Italian: italianFlashcards,
  Japanese: japaneseFlashcards,
  Kannada: kannadaFlashcards,
  Latin: latinFlashcards,
  Malayalam: malayalamFlashcards,
  Marathi: marathiFlashcards,
  Portuguese: portugueseFlashcards,
  Punjabi: punjabiFlashcards,
  Russian: russianFlashcards,
  Spanish: spanishFlashcards,
  Tamil: tamilFlashcards,
  Telugu: teluguFlashcards,
  Urdu: urduFlashcards,
};
